import { useParams, Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import Breadcrumb from '@/components/feature/Breadcrumb';
import ComicCard from '@/components/feature/ComicCard';
import { categories, getComicsByCategory } from '@/mocks/comics';

export default function CategoryPage() {
  const { slug } = useParams<{ slug: string }>();
  const category = categories.find((c) => c.slug === slug);
  const comics = slug ? getComicsByCategory(slug) : [];

  const categoryName = category?.name || '漫画分类';

  const webPageSchema = {
    '@context': 'https://schema.org',
    '@type': 'CollectionPage',
    name: `${categoryName} - 妖精漫画`,
    description: `妖精漫画${categoryName}专区，精选优质${categoryName}作品，免费在线阅读。`,
    url: `https://yaojingmanhua.com/category/${slug}`,
    isPartOf: {
      '@type': 'WebSite',
      name: '妖精漫画',
      url: 'https://yaojingmanhua.com',
    },
  };

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(webPageSchema)}</script>
      <ScrollToTop />
      <Navbar />
      <main className="pt-16">
        <div className="bg-background-100 border-b border-background-200/70">
          <div className="max-w-[1280px] mx-auto px-4 md:px-6 py-8">
            <Breadcrumb
              items={[
                { label: '首页', to: '/' },
                { label: categoryName },
              ]}
            />
            <div className="flex items-center gap-3 mt-2">
              <div className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-100 text-primary-500">
                <i className={`${category?.icon || 'ri-book-line'} text-lg`}></i>
              </div>
              <div>
                <h1 className="text-2xl md:text-3xl font-bold text-foreground-900 font-heading">
                  {categoryName}
                </h1>
                <p className="text-sm text-foreground-500 mt-1">
                  共 {comics.length} 部作品
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="max-w-[1280px] mx-auto px-4 md:px-6 py-6">
          <div className="flex items-center gap-2 mb-6 overflow-x-auto flex-wrap">
            {categories.map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className={`flex items-center gap-1 px-4 py-2 rounded-full text-sm font-medium whitespace-nowrap transition-all cursor-pointer ${
                  slug === cat.slug
                    ? 'bg-primary-500 text-background-50'
                    : 'bg-background-100 text-foreground-600 hover:bg-background-200'
                }`}
              >
                <i className={`${cat.icon} text-sm`}></i>
                {cat.name}
              </Link>
            ))}
          </div>

          {comics.length > 0 ? (
            <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4 md:gap-5">
              {comics.map((comic) => (
                <ComicCard key={comic.id} comic={comic} />
              ))}
            </div>
          ) : (
            <div className="text-center py-20">
              <div className="w-16 h-16 mx-auto mb-4 flex items-center justify-center rounded-full bg-background-200 text-foreground-400">
                <i className="ri-emotion-sad-line text-2xl"></i>
              </div>
              <p className="text-foreground-500">该分类下暂无漫画作品</p>
              <Link to="/" className="btn-primary mt-4 text-sm">
                返回首页
              </Link>
            </div>
          )}
        </div>
      </main>
      <Footer />
    </>
  );
}